import { render, staticRenderFns } from "./LivechairLogo.vue?vue&type=template&id=7ffa4bba&scoped=true"
import script from "./LivechairLogo.vue?vue&type=script&lang=js"
export * from "./LivechairLogo.vue?vue&type=script&lang=js"
import style0 from "./LivechairLogo.vue?vue&type=style&index=0&id=7ffa4bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa4bba",
  null
  
)

export default component.exports